module.exports = __webpack_public_path__ + "img/download-report.e307e3e4.svg";